"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevStatsMetricNameInDatabase = exports.AcumenMetricGroupType = exports.MetricInterval = void 0;
var MetricInterval;
(function (MetricInterval) {
    MetricInterval["MONTH"] = "month";
    MetricInterval["WEEK"] = "week";
    MetricInterval["DAY"] = "day";
    MetricInterval["SPRINT"] = "sprint";
    MetricInterval["SPRINT_DATE"] = "sprint_date";
    MetricInterval["DEV_CYCLE"] = "dev_cycle";
    MetricInterval["DEV_CYCLE_DATE"] = "dev_cycle_date";
    MetricInterval["DAYS_7"] = "7_days";
    MetricInterval["DAYS_30"] = "30_days";
})(MetricInterval = exports.MetricInterval || (exports.MetricInterval = {}));
var AcumenMetricGroupType;
(function (AcumenMetricGroupType) {
    AcumenMetricGroupType["JiraIssueCount"] = "JiraIssueCount";
    AcumenMetricGroupType["JiraIssueAverageLeadTime"] = "JiraIssueAverageLeadTime";
    AcumenMetricGroupType["JiraIssueLeadTimeSum"] = "JiraIssueLeadTimeSum";
    AcumenMetricGroupType["JiraIssueCycleTimeSum"] = "JiraIssueCycleTimeSum";
    AcumenMetricGroupType["GitHubPullRequestCount"] = "GitHubPullRequestCount";
    AcumenMetricGroupType["GitHubPullRequestCycleSum"] = "GitHubPullRequestCycleSum";
    AcumenMetricGroupType["JiraIssuesWorkIntervalSum"] = "JiraIssuesWorkIntervalSum";
    AcumenMetricGroupType["GitHubCommitWorkIntervalSum"] = "GitHubCommitWorkIntervalSum";
    AcumenMetricGroupType["GitHubPullRequestWorkIntervalSum"] = "GitHubPullRequestWorkIntervalSum";
    AcumenMetricGroupType["GitHubPullRequestLinesOfCodeChangedSum"] = "GitHubPullRequestLinesOfCodeChangedSum";
    AcumenMetricGroupType["GitHubPullRequestLinesOfCodeAddedSum"] = "GitHubPullRequestLinesOfCodeAddedSum";
    AcumenMetricGroupType["GitHubPullRequestLinesOfCodeDeletedSum"] = "GitHubPullRequestLinesOfCodeDeletedSum";
    AcumenMetricGroupType["GitHubCommitCount"] = "GitHubCommitCount";
    AcumenMetricGroupType["JiraIssuesEstimatedEffortStoryPoints"] = "JiraIssuesEstimatedEffortStoryPoints";
    AcumenMetricGroupType["JiraIssuesEstimatedEffortTimeEstimate"] = "JiraIssuesEstimatedEffortTimeEstimate";
    AcumenMetricGroupType["JiraIssuesPlannedEffortTimeEstimate"] = "JiraIssuesPlannedEffortTimeEstimate";
    AcumenMetricGroupType["JiraIssuesPlannedEffortStoryPoints"] = "JiraIssuesPlannedEffortStoryPoints";
    AcumenMetricGroupType["JiraIssuesActualEffortTimeEstimate"] = "JiraIssuesActualEffortTimeEstimate";
    AcumenMetricGroupType["JiraIssuesActualEffortStoryPoints"] = "JiraIssuesActualEffortStoryPoints";
    AcumenMetricGroupType["JiraIssuesCountPlanned"] = "JiraIssuesCountPlanned";
    AcumenMetricGroupType["WorkIntervalSum"] = "WorkIntervalSum";
    AcumenMetricGroupType["AcumenEventsCount"] = "AcumenEventsCount";
    AcumenMetricGroupType["GithubPullRequestStatusPerDay"] = "GithubPullRequestStatusPerDay";
    AcumenMetricGroupType["DeploymentFrequency"] = "DeploymentFrequency";
    AcumenMetricGroupType["GitHubPullRequestsReviewedCount"] = "PullRequestReviewCount";
    AcumenMetricGroupType["JiraIssuesActualEffortNoneEstimation"] = "JiraIssuesActualEffortNoneEstimation";
    AcumenMetricGroupType["JiraIssuesPlannedEffortNoneEstimation"] = "JiraIssuesPlannedEffortNoneEstimation";
    AcumenMetricGroupType["DailyDevStats"] = "DailyDevStats";
    AcumenMetricGroupType["HighestBugsLeadTime"] = "HighestBugsLeadTime";
    AcumenMetricGroupType["HighestBugsTotal"] = "HighestBugsTotal";
    AcumenMetricGroupType["GithubPullRequestCommentsCount"] = "GithubPullRequestCommentsCount";
    AcumenMetricGroupType["JiraIssueStatusTimeSpentSumSeconds"] = "JiraIssueStatusTimeSpentSumSeconds";
})(AcumenMetricGroupType = exports.AcumenMetricGroupType || (exports.AcumenMetricGroupType = {}));
var DevStatsMetricNameInDatabase;
(function (DevStatsMetricNameInDatabase) {
    DevStatsMetricNameInDatabase["active_days"] = "active_days";
    DevStatsMetricNameInDatabase["resolved_tasks"] = "resolved_tasks";
    DevStatsMetricNameInDatabase["merged_prs"] = "merged_prs";
    DevStatsMetricNameInDatabase["pr_cycle_time_sum_seconds"] = "pr_cycle_time_sum_seconds";
    DevStatsMetricNameInDatabase["pr_coding_time_sum_seconds"] = "pr_coding_time_sum_seconds";
    DevStatsMetricNameInDatabase["pr_pending_review_time_sum_seconds"] = "pr_pending_review_time_sum_seconds";
    DevStatsMetricNameInDatabase["pr_review_time_sum_seconds"] = "pr_review_time_sum_seconds";
    DevStatsMetricNameInDatabase["pr_pending_merge_time_sum_seconds"] = "pr_pending_merge_time_sum_seconds";
    DevStatsMetricNameInDatabase["reviewed_prs"] = "reviewed_prs";
    DevStatsMetricNameInDatabase["opened_prs"] = "opened_prs";
    DevStatsMetricNameInDatabase["closed_unmerged_prs"] = "closed_unmerged_prs";
    DevStatsMetricNameInDatabase["completed_high_priority_tasks"] = "completed_high_priority_tasks";
    DevStatsMetricNameInDatabase["lines_of_code"] = "lines_of_code";
    DevStatsMetricNameInDatabase["velocity"] = "velocity";
    DevStatsMetricNameInDatabase["pr_coding_and_review_time_sum_seconds"] = "pr_coding_and_review_time_sum_seconds";
    DevStatsMetricNameInDatabase["lead_time_seconds"] = "lead_time_seconds";
    DevStatsMetricNameInDatabase["completed_highest_priority_bugs_count"] = "completed_highest_priority_bugs_count";
    DevStatsMetricNameInDatabase["highest_priority_bugs_lead_time_seconds"] = "highest_priority_bugs_lead_time_seconds";
    DevStatsMetricNameInDatabase["resolved_bugs"] = "resolved_bugs";
    DevStatsMetricNameInDatabase["bugs_velocity"] = "bugs_velocity";
    DevStatsMetricNameInDatabase["pr_comments"] = "pr_comments";
})(DevStatsMetricNameInDatabase = exports.DevStatsMetricNameInDatabase || (exports.DevStatsMetricNameInDatabase = {}));
//# sourceMappingURL=metrics.js.map